<template>
  <v-progress-circular v-if="hasProgress" :model-value="progressPercent" size="25" width="3">
    {{ progressPercent }}
  </v-progress-circular>
  <v-tooltip v-else location="bottom">
    <template #activator="{ props }">
      <v-btn
        v-bind="props"
        variant="text"
        density="comfortable"
        icon="mdi-content-copy"
        :loading="copyInProgress"
        :disabled="disabled"
        @click="onCopyWorkpackageClick"
      />
    </template>
    <span>{{ $t('actions.copy') }}</span>
  </v-tooltip>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { includes, get } from 'lodash';
import jobapi from '@enums/jobapi';
import { usePermission } from '@/composables/use-permission';
import { useWorkpackagesStore } from '@/stores/workpackages';
import { useSnackbarStore } from '@/stores/snackbar';

export default {
  props: {
    workpackage: {
      required: true,
      type: Object,
    },
  },

  setup() {
    const { canCopyWorkpackage } = usePermission();

    return { canCopyWorkpackage };
  },
  computed: {
    ...mapState(useWorkpackagesStore, ['jobStatuses', 'isCopyWorkpackageRunning']),
    disabled() {
      return this.isCopyWorkpackageRunning || !this.canCopyWorkpackage;
    },
    copyWorkpackageJobStatus() {
      return get(this.workpackage, 'jobs.copyWorkpackage.status');
    },
    copyInProgress() {
      return includes(jobapi.jobInProgressStatuses, this.copyWorkpackageJobStatus);
    },
    progressPercent() {
      return get(this.workpackage, 'jobs.copyWorkpackage.progress');
    },
    hasProgress() {
      return this.copyInProgress && this.progressPercent > 0 && this.progressPercent < 100;
    },
  },
  methods: {
    ...mapActions(useWorkpackagesStore, ['copyWorkpackage', 'setSelectedWorkpackage']),
    ...mapActions(useSnackbarStore, ['showSuccess', 'showError']),
    async onCopyWorkpackageClick() {
      this.setSelectedWorkpackage(this.workpackage);
      this.showSuccess(
        this.$t('notifications.copyWorkpackage.starting', { name: this.workpackage.name })
      );
      await this.copyWorkpackage(this.workpackage);
    },
  },
};
</script>
